import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202510",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 76630,
  clicks: 1710,
  adsSpendDollars: 3556,
  budgetDollars: 4000,
  salesDollars: 13884,
  bestEstimateRoas: 3.9,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.89,
  newCustomersAcquired: 22,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
